import styled from "styled-components";

export const FormContainer = styled.div`
  display: grid;
  place-items: center;
  height: 100vh;
`;
